import React, { useState } from "react";
import { ActionButton, Button, Thumbnail, Tooltip } from "@culturehq/components";

import { useProfile } from "app/context";
import { ProfileLink } from "app/links";
import { t, Trans } from "app/utils";

import { RecognitionTypeMediumImage } from "components/recognitions/RecognitionTypeImage";
import LazyEditor from "components/editor/LazyEditor";
import SlackChannelField from "components/event/edit/SlackChannelField";

import RecognizeAddValue from "./RecognizeAddValue";
import styles from "./styles.module.scss";

const RecognizeButton = ({ disabled, type, onSubmit, profile }) => {
  if (profile.organizationAdmin || type.approval !== "approval_needed") {
    return (
      <Button disabled={disabled} primary onClick={onSubmit}>
        <Trans>Recognize</Trans>
      </Button>
    );
  }

  return (
    <Tooltip tip={t("Your chosen type of recognition requires approval from an admin before it appears in the feed.")}>
      <Button disabled={disabled} primary onClick={onSubmit}>
        <Trans>Submit</Trans>
      </Button>
    </Tooltip>
  );
};

const RecognizeWriteBody = ({
  type, users, onPrevClicked, onSelectedChannel,
  onSubmit, onValueSelected, editorRef
}) => {
  const { profile } = useProfile();
  const [submitEnabled, setSubmitEnabled] = useState(false);
  const [editorPadding, setEditorPadding] = useState({ paddingBottom: "55px" });

  const handleTagsChanged = (newOptions, selectHeight) => {
    setEditorPadding({ paddingBottom: `${selectHeight + 35}px` });
    onValueSelected(newOptions);
  };

  return (
    <>
      <ActionButton className={styles.prev} onClick={onPrevClicked}>
        <Trans>← Go back</Trans>
      </ActionButton>
      <div className="recognize__preview">
        <div className="recognize__preview-gutter" />
        <div className="recognize__preview-box">
          {type.name}<br />
          <RecognitionTypeMediumImage
            className="recognize__type-thumb"
            recognitionType={type}
          />
        </div>
        <div className="recognize__preview-center">
          <Trans>to</Trans>
        </div>
        <div className="recognize__preview-box">
          {users.length === 1 ? (
            <>
              <ProfileLink user={users[0]} />
              <br />
              <Thumbnail
                className="recognize__user-thumb"
                size="medium"
                image={users[0].avatar.thumbUrl}
              />
            </>
          ) : (
            <>
              <span>{users.length} people</span><br />
              {users.slice(0, 4).map(user => (
                <Thumbnail
                  key={user.id}
                  className="recognize__user-thumb"
                  size="medium"
                  image={user.avatar.thumbUrl}
                />
              ))}
            </>
          )}
        </div>
        <div className="recognize__preview-gutter" />
      </div>
      <h2>
        <Trans>Description</Trans>
      </h2>
      <div className="chq-ffd">
        <LazyEditor
          forzeOpen
          ref={editorRef}
          onEmptyChange={setSubmitEnabled}
          placeholder={t(`Complete your recognition by adding a little more context. Ex. ${users[0].name} always goes above and beyond!`)}
          style={editorPadding}
        />
        <RecognizeAddValue onValueSelected={handleTagsChanged} />
      </div>
      <div className="chq-pan--ft">
        <SlackChannelField
          className="modal-footer-column"
          imageIconPath="/slack.png"
          showLabel={false}
          onSelectedChannel={onSelectedChannel}
          disabled={!profile.organizationAdmin && type.approval === "approval_needed"}
          page="recognitions"
        />
        <RecognizeButton
          disabled={!submitEnabled}
          type={type}
          onSubmit={onSubmit}
          profile={profile}
        />
      </div>
    </>
  );
};

export default RecognizeWriteBody;
